/* eslint-disable camelcase */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import moment from 'moment';

import { DEFAULT_FIELD_VALIDATION_TYPE, useAppConfig, StatusCodes } from '@config/AppConfig';
import { useStaticContent } from '@context/StaticContent';
import { useMobileOne } from '@dom-digital-online-media/dom-mo-sdk';
import {
  AutoTopUpFor,
  appAlert,
  appAutoTopUpPeriodType,
  appPaymentMethods,
  appPaymentProductType,
  appRegex,
  appRoute,
  appStorage,
  appTopUpTo,
  appTopUpType,
  formValidation,
  generateUUID,
  gettingNumberForGerman,
  inputValidation,
  validateDOBde,
  getGenericErrorMessage,
  validCharRegex,
  getForbiddenCharError
} from '@utils/globalConstant';
import { useAlert } from '@context/Utils/Alert';
import { DEFAULT_SALUTATION_DATA } from '@utils/defaultLookups';
import { useNavigate } from 'react-router-dom';
import { replaceDynamicCmsContent, tA11y } from '@utils/a11y/a11yHelpers';
import { useLoader } from '@context/Utils';
import paymentService from '@services/payment';

export const ActivationContext = createContext({});

export function ActivationContextProvider({ children, config: { storage } }) {
  // States
  // API Data Storage States
  const [isLoading, setIsLoading] = useState(false);
  const [isPaymentProductLoading, setIsPaymentProductLoading] = useState(false);
  const [isPaymentMethodLoading, setIsPaymentMethodLoading] = useState(false);

  const [ip, setIp] = useState('');

  const [bookableTariffs, setBookableTariffs] = useState([]);
  const [bookableTariffsEtcOne, setBookableTariffsEtcOne] = useState([]);
  const [selectedTariffId, setSelectedTariffId] = useState(0);
  const [paymentProducts, setPaymentProducts] = useState([]);
  const [allPaymentProducts, setAllPaymentProducts] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [simProvider, setSimProvider] = useState([]);
  const [areaCode, setAreaCode] = useState([]);
  const [salutations, setSalutations] = useState([]);
  const [countries, setCountries] = useState([]);
  const [identityTypes, setIdentityTypes] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [isChargingClicked, setIsChargingClicked] = useState(true);
  const [isSimInvalid, setIsSimInvalid] = useState(false);
  const [activateSimSuccessPopup, setActivateSimSuccessPopup] = useState(false);
  const [showBackButton, setShowBackButton] = useState(true);
  const [isActivationClicked, setIsActivationClicked] = useState(false);
  const [emailUniqueId, setEmailUniqueId] = useState('');
  const [emailCodeError, setEmailCodeError] = useState(false);
  const [isAutoLowEnabled, setIsAutoLowEnabled] = useState(false);

  // Special data for some other unique inputs
  const [otherAmount, setOtherAmount] = useState(''); // Input for Direct topup
  // To show address after product selection in payment activation
  const [showAddress, setShowAddress] = useState(false);
  // TODO: Store data in storage for verification once callback / returns.
  const [cartName, setCartName] = useState(null); // Cart ID / Name when added to card.
  const [paymentAuthData, setPaymentAuthData] = useState({});
  const [orderNumber, setOrderNumber] = useState(null); // order ID / Name when processed with payment.
  const [paymentUrl, setPaymentUrl] = useState(null);
  const [postIdentUrl, setPostIdentUrl] = useState(null);
  const [autoTopupMoreInfo, setAutoTopupMoreInfo] = useState(false);
  const [changePasswordErrorMsg, setChangePasswordErrorMsg] = useState('');
  const [formError, setFormError] = useState(null);

  // Activation steps
  const [currentStep, setCurrentStep] = useState(0);
  // const [currentStep, setCurrentStep] = useState(9); // FOR TESTING PURPOSE
  const [step0SubStep, setStep0SubStep] = useState(0);
  const [step1SubStep, setStep1SubStep] = useState(0);
  const [step2SubStep, setStep2SubStep] = useState(0);
  const [step3SubStep, setStep3SubStep] = useState(0);
  const [step4SubStep, setStep4SubStep] = useState(0);
  const [step5SubStep, setStep5SubStep] = useState(0);
  const [step6SubStep, setStep6SubStep] = useState(0);
  const [step7SubStep, setStep7SubStep] = useState(0);
  const [step8SubStep, setStep8SubStep] = useState(0);
  const [step9SubStep, setStep9SubStep] = useState(0);
  const [step10SubStep, setStep10SubStep] = useState(0);

  const [showActivationHeader, setShowActivationHeader] = useState(false);
  // const [showActivationHeader, setShowActivationHeader] = useState(true); // FOR TESTING PURPOSE
  const [showActivationFooter, setShowActivationFooter] = useState(true);
  const [showActivationCancelModal, setShowActivationCancelModal] = useState(false);
  const [showFeedbackSuccess, setShowFeedbackSuccess] = useState(false);
  const [showFeedbackError, setShowFeedbackError] = useState(false);

  // set this true for with MPN
  const [withMNP, setWithMNP] = useState(false);
  const [withVoucher, setWithVoucher] = useState(false);

  const [validateAddressRes, setValidateAddressRes] = useState(null);
  const [initialAddressParam, setInitialAddressParam] = useState(null);
  const [voucherGBNo, setVoucherGBNo] = useState('');

  // Voucher Error
  const [voucherCodeError, setVoucherCodeError] = useState(null);

  const [vviDocuments, setVviDocuments] = useState();

  // Auto topup
  const [withAutoTopup, setWithAutoTopup] = useState(false);
  const [errorAutoTopup, setErrorAutoTopup] = useState(true);

  // Legitimation
  const [legitimationMethods, setLegitimationMethods] = useState([]);
  const [legitimationError, setLegitimationError] = useState(null);

  // this state will be set after successful response of dom-activate-sim
  // contains (Vorgangsnummer | process number) which can be copied in step 10
  const [legitimationCode, setLegitimationCode] = useState('');
  // this state will be set after successful response of dom-activate-sim
  // contains url from response
  const [legitimationUrl, setLegitimationUrl] = useState('');

  const [countriesError, setCountriesError] = useState(null);
  const [areaCodeError, setAreaCodeError] = useState(null);
  const [simProviderError, setSimProviderError] = useState(null);
  const [overviewError, setOverviewError] = useState(null);
  const [withMNPError, setWithMNPError] = useState(false);

  // Context
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const { showAlert } = useAlert();
  const { env } = useAppConfig();
  const { t, staticContentData, getStaticContentValue } = useStaticContent();
  // const {ek_ap_personal_first-name_input_error-msg} = t();

  const {
    onValidateSim,
    onValidateAddress,
    oncountriesCall,
    onIdentityTpesCall,
    onsalutationCall,
    onNationalitiesCall,
    onAreaCode,
    onSimProvider,
    onTwoFactorAuthPinCall,
    onTwoFactorAuthVerificationCall,
    onValidateCode,
    onVviDocuments,
    onLegitimationMethodsCall
    // onChangePasswordCall
  } = useMobileOne();
 
  // 🔴 [STATE RECOVERY] Restore state from sessionStorage on mount
  // This handles state loss when PayPal redirect clears React Context
  useEffect(() => {
    // Restore legitimationMethods
    const storedMethods = sessionStorage.getItem('mps_legitimation_methods');
    if (storedMethods && (!legitimationMethods || legitimationMethods.length === 0)) {
      try {
        const parsedMethods = JSON.parse(storedMethods);
        setLegitimationMethods(parsedMethods);
      } catch (err) {
        // console.error('Failed to parse legitimationMethods from sessionStorage:', err);
      }
    }

    // Restore bookableTariffs
    const storedTariffs = sessionStorage.getItem('mps_bookable_tariffs');
    if (storedTariffs && (!bookableTariffs || bookableTariffs.length === 0)) {
      try {
        const parsedTariffs = JSON.parse(storedTariffs);
        setBookableTariffs(parsedTariffs);
      } catch (err) {
        // console.error('Failed to parse bookableTariffs from sessionStorage:', err);
      }
    }

    // Restore bookableTariffsEtcOne
    const storedTariffsEtcOne = sessionStorage.getItem('mps_bookable_tariffs_etc_one');
    if (storedTariffsEtcOne && (!bookableTariffsEtcOne || bookableTariffsEtcOne.length === 0)) {
      try {
        const parsedTariffsEtcOne = JSON.parse(storedTariffsEtcOne);
        setBookableTariffsEtcOne(parsedTariffsEtcOne);
      } catch (err) {
        // console.error('Failed to parse bookableTariffsEtcOne from sessionStorage:', err);
      }
    }
  }, []);

  function validateForbiddenChar(forbiddenPattern, errorMessageKey) {
    return Yup.string().test(
      'forbidden-chars',
      errorMessageKey, // this will be used as the message if test fails
      function (value) {
        const { path, createError } = this;
        const errorMessage = getForbiddenCharError(value, forbiddenPattern);

        if (errorMessage) {
          // Return same error message key (example: ek_global_email_err)
          return createError({ path, message: errorMessageKey });
        }

        return true;
      }
    );
  }

  // Step 1 - Phone Number Initial Values & Validations
  const phoneNumberInitialValue = {
    msisdn: '',
    iccid: '',
    puk: '',
    mnp: null,
    email: '',
    emailCode: '',
    currentProvider: '',
    type: '1',
    oldNumber: '',
    oldNumberPrefix: ''
  };

  // Generic error message
  const genericErrorMessage = getGenericErrorMessage(tA11y);

  const phoneNumberValidations = Yup.object().shape({
    msisdn: formValidation({
      required: 'ek_global_phone_nmbr_err',
      regex: /^\d{5,20}$/,
      validErrorMessage: 'ek_global_phone_nmbr_err'
    }),
    puk: formValidation({
      required: 'ek_global_puk_err',
      regex: /^\d{4,8}$/,
      validErrorMessage: 'ek_global_puk_err'
    })
  });

  const phoneNumberValidationsWithMNP = Yup.object().shape({
    currentProvider: Yup.string().required('ek_global_prvdr_err'),
    oldNumberComplete: Yup.string()
      .required('ek_global_mnp_nmbr_err')
      .matches(/^\d{5,16}$/, 'ek_global_mnp_nmbr_err'),
    portingOrder: Yup.bool().oneOf([true], 'ek_reg_with_mnp_chckbox_err')
  });

  const validationSchemaEmail = Yup.object().shape({
    email: Yup.string()
      .required('ek_global_email_err')
      .email('ek_global_email_err')
      .concat(validateForbiddenChar(validCharRegex.EMAIL, 'ek_global_email_err'))
  });

  const staticTariffManipulation = (tariffApiData) => {
    const staticApiData = staticContentData;

    if (staticApiData != null) {
      if (staticApiData.ek_tariff != null && staticApiData.ek_tariff.length > 0) {
        let staticContentTariff = staticApiData.ek_tariff;
        let apiTariffData = tariffApiData;
        let filterArray = [];

        filterArray = staticContentTariff.filter((staticContentTariffItem) =>
          apiTariffData.some(
            (apiTariffDataitem) => staticContentTariffItem.id === apiTariffDataitem.id
          )
        );

        // eslint-disable-next-line prefer-arrow-callback
        filterArray.sort(function (x, y) {
          return x.sortOrder - y.sortOrder;
        });

        // Move recommended item to index 0
        let recommendedIndex = filterArray.findIndex((item) => item.recommended);
        if (recommendedIndex !== -1 && recommendedIndex !== 0) {
          let recommendedItem = filterArray.splice(recommendedIndex, 1)[0];
          filterArray.unshift(recommendedItem);
        }

        return filterArray;
      }
      return tariffApiData;
    }
    return tariffApiData;
  };

  const validationSchemaCode = Yup.object().shape({
    // changed validation for emailCode to string although wrong and contradictory to API specification
    // which requires a number, project management wanted to make frontend error message disappear for
    // "numbers" with a leading zero --> validation responsibility is shifted to ETC One backend
    emailCode: Yup.string()
      .typeError('ek_global_2fa_code_err')
      .required('ek_global_2fa_code_err')
      .test('code', 'ek_global_2fa_code_err', (hp) => /^\d{4}$/.test(hp))
  });

  const [phoneNumberActivationForm, setPhoneNumberActivationForm] =
    useState(phoneNumberInitialValue);

  // Step 2 - Tariff Activation Initial Values & Validations
  const tariffActivationInitialValue = {
    chosenTariffId: 0,
    chosenTariffName: '',
    tariffColor: '',
    tariffPrice: '', // as string (CMS key from nc_tariff JSON)
    tariffAmount: 0, // as number (taken from original tariff data and stored in activation step 2)
    tariffAmountAsStr: '' // as string (converted from original tariff data and stored in activation step 2)
  };
  const tariffActivationValidation = Yup.object().shape({
    chosenTariffId: formValidation({
      type: DEFAULT_FIELD_VALIDATION_TYPE.NUMBER,
      required: 'required_field'
    })
  });
  const [tariffActivationForm, setTariffActivationForm] = useState(tariffActivationInitialValue);

  // Step 3 - Personal Data Initial Values & Validations
  const personalDataInitialValue = {
    firstName: '',
    lastName: '',
    birthDate: '',
    houseNumber: '',
    street: '',
    zip: '',
    city: '',
    countryCode: 1, // "Deutschland" is selected by default
    emailAddress: '',
    legitimationMethod: 0,
    legitimationName: '',
    title: '7',
    invitationCode: ''
  };

  const personalDataValidations = Yup.object().shape({
    firstName: formValidation({
      required: 'ek_global_name_err',
      regex: /^[a-zA-Z(Ö)(Ä)(Ü)(ü)(ö)(ä)(ß)\s\x2D]{0,25}$/,
      validErrorMessage: 'ek_global_name_err'
    }),
    lastName: formValidation({
      required: 'ek_global_surname_err',
      regex: /^[a-zA-Z(Ö)(Ä)(Ü)(ü)(ö)(ä)(ß)\s\x2D]{0,40}$/,
      validErrorMessage: 'ek_global_surname_err'
    }),
    birthDate: Yup.date()
      .transform((value, originalValue) => {
        // Parse the date using Moment.js
        const parsedDate = moment(originalValue, 'DD.MM.YYYY', true); // strict parsing
        // If the date is valid and the day and month match the original values, return the date object
        // Otherwise, return an `InvalidDate`
        if (parsedDate.isValid()) {
          const [day, month, year] = originalValue.split('.');
          if (
            parsedDate.date() === parseInt(day, 10) &&
            parsedDate.month() + 1 === parseInt(month, 10)
          ) {
            return parsedDate.toDate();
          }
        }
        return new Date(NaN); // Invalid date
      })
      .max(validateDOBde(), 'ek_global_brthdy_err')
      .required('ek_global_brthdy_err')
      .typeError('ek_global_brthdy_err'),

    street: formValidation({
      required: 'ek_global_street_err',
      regex: /^.{0,100}$/,
      validErrorMessage: 'ek_global_street_err'
    }),
    houseNumber: formValidation({
      required: 'ek_global_house_number_err',
      // regex: /^[A-Za-z0-9ÄÖÜßäöü.-]{0,25}$/,
      regex: /^.{0,25}$/,
      validErrorMessage: 'ek_global_house_number_err'
    }),
    zip: formValidation({
      required: 'ek_global_zip_err',
      regex: /^[0-9]{0,25}$/,
      validErrorMessage: 'ek_global_zip_err'
    }),
    city: formValidation({
      required: 'ek_global_place_err',
      regex: /^.{0,75}$/,
      validErrorMessage: 'ek_global_place_err'
    }),
    countryCode: formValidation({
      required: 'ek_global_country_err'
    })
  });

  const [personalDataForm, setPersonalDataForm] = useState(personalDataInitialValue);

  // Step 5 - Login Password Initial Values & Validations
  const loginPasswordInitialValue = {
    cscPassword: '',
    confirmCscPassword: ''
  };

  const [loginPasswordForm, setLoginPasswordForm] = useState(loginPasswordInitialValue);

  // Regex for password validation
  const globalPasswordRegex = tA11y('ek_global_pw_regex').content;
  const stringLengthRegex = tA11y('ek_global_pw_string-length_regex').content;
  const upperOrLowerCaseRegex = tA11y('ek_global_pw_upper-or-lower-case_regex').content;
  const numbersRegex = tA11y('ek_global_pw_numbers_regex').content;
  const specialCharsRegex = tA11y('ek_global_pw_special-chars_regex').content;

  // Global password regex error message
  const errorMessageInvalidChar = tA11y('ek_global_pw_invalid-char_err').content;

  // Password match error message
  const errorMessagePasswordMatch = tA11y('ek_global_pw_match_err').content;

  const validatePwd = (password) => {
    const pattern =
      globalPasswordRegex !== 'ek_global_pw_regex'
        ? new RegExp(`${globalPasswordRegex}`)
        : appRegex.validatePwd;
    return pattern.test(password);
  };

  const validatePwdStringLength = (password) => {
    const pattern =
      stringLengthRegex !== 'ek_global_pw_string-length_regex'
        ? new RegExp(`${stringLengthRegex}`)
        : appRegex.validatePwdStringLength;
    return pattern.test(password);
  };

  const validatePwdUpperOrLowerCase = (password) => {
    const pattern =
      upperOrLowerCaseRegex !== 'ek_global_pw_upper-or-lower-case_regex'
        ? new RegExp(`${upperOrLowerCaseRegex}`)
        : appRegex.validatePwdUpperOrLowerCase;
    return pattern.test(password);
  };

  const validatePwdNumbers = (password) => {
    const pattern =
      numbersRegex !== 'ek_global_pw_numbers_regex'
        ? new RegExp(`${numbersRegex}`)
        : appRegex.validatePwdNumbers;
    return pattern.test(password);
  };

  const validatePwdSpecialChar = (password) => {
    const pattern =
      specialCharsRegex !== 'ek_global_pw_special-chars_regex'
        ? new RegExp(`${specialCharsRegex}`)
        : appRegex.validatePwdSpecialChar;
    return pattern.test(password);
  };

  // Password Validation
  const validatePasswordWithKeys = (values, firstPasswordKey, confirmPasswordKey) => {
    // string, controlName, password

    // setChangePasswordErrorMsg('');
    // if (!values[firstPasswordKey] && !values[confirmPasswordKey]) return {};
    const errors = Object.keys(values).map((controlName) => {
      const string = values[controlName];
      // TODO: is this check necessary?
      // it's a check on non-existing field but field name was passed as a parameter to the function
      if (!string) {
        return {
          [controlName]: 'Pflichtfeld' // BFSG: add key
        };
      }

      // const hasVerified = !validatePwd(values[firstPasswordKey]);
      const hasLength = !validatePwdStringLength(values[firstPasswordKey]);
      const hasUpperCase = !validatePwdUpperOrLowerCase(values[firstPasswordKey]);
      const hasLowerCase = !validatePwdUpperOrLowerCase(values[firstPasswordKey]);
      const hasNumber = !validatePwdNumbers(values[firstPasswordKey]);
      const hasSpecial = !validatePwdSpecialChar(values[firstPasswordKey]);

      let errorMsg = {};

      if (
        // hasVerified ||
        hasLength ||
        hasUpperCase ||
        hasLowerCase ||
        hasNumber ||
        hasSpecial ||
        values[firstPasswordKey] !== values[confirmPasswordKey]
      ) {
        errorMsg = {
          [confirmPasswordKey]: errorMessageInvalidChar, // NEW
          otherErrors: {
            // [inputValidation.INVALID]: hasVerified,
            [inputValidation.MIN_MAX_ERROR]: hasLength,
            [inputValidation.UPPER_CASE_ERROR]: hasUpperCase,
            [inputValidation.LOWER_CASE_ERROR]: hasLowerCase,
            [inputValidation.NUMBER_ERROR]: hasNumber,
            [inputValidation.SPECIAL_CASE_ERROR]: hasSpecial,
            [inputValidation.MATCH]: values[firstPasswordKey] !== values[confirmPasswordKey]
          }
        };
      }

      if (
        values[firstPasswordKey] &&
        values[confirmPasswordKey] &&
        values[firstPasswordKey] !== values[confirmPasswordKey]
      ) {
        errorMsg = { ...errorMsg, [confirmPasswordKey]: errorMessagePasswordMatch };
      }

      return errorMsg;
    });
    return Object.assign(...errors);
  };

  // Step [] - Overview Initial Values & Validations
  const overviewInitialValue = {
    // REFACTOR: Remove potentially unused field 'voucher'
    voucher: '',
    termsAndConditions: false,
    thirdParty: false,
    acceptedCreditCheck: false,
    brandPartnerCustomMarketing: false,
    employee: false,
    marketingMultibrand: false
  };
  const overviewValidation = Yup.object().shape({
    msisdn: formValidation({
      required: t('ek_ap_activation_nr_input_error-msg'),
      regex: /^\d{10,12}$/,
      validErrorMessage: t('ek_ap_activation_nr_input_error-msg')
    }),
    // NOTE: as edit button is deactivated in overview in activation journey,
    // this validation is not required
    // NOTE: if edit button is activated in overview, this validation needs to be refactored,
    // because it is not the correct one as it is necessary from Password CR on (July 2024)
    // cscPassword: formValidation({
    //   required: t('ek_ap_password_pw1_error-msg'),
    // NOTE: OLD INCORRECT PASSWORD REGEX --> please have a look in function 'validatePasswordWithKeys'
    //   regex:
    //   validErrorMessage: t('ek_ap_password_pw1_error-msg')
    // }),
    // NOTE: as edit button is deactivated in overview in activation journey
    // hotlinePassword: formValidation({
    //   required: t('ek_ap_personal_holine-pw_input1_error-msg'),
    //   regex: /^[(A-Z)|(Ö)|(Ä)|(Ü)|(a-z)|(0-9)|(ü)|(ö)|(ä)|(ß)]{4,20}$/,
    //   validErrorMessage: t('ek_ap_personal_holine-pw_input1_error-msg')
    // }),
    countryCode: formValidation({
      required: t('ek_ap_personal_country_input_error-msg'),
      regex:
        /^[a-zA-Z0-9-`ºªµ¼½¿ÀÁÂÃÄÅÆÇÈÉÊÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿœŒ´¡]{1,11}$/,
      validErrorMessage: t('ek_ap_personal_country_input_error-msg')
    }),
    // salutation: Yup.string().required(t('ek_ap_personal_h1_error-msg')),
    firstName: formValidation({
      required: t('ek_ap_personal_first-name_input_error-msg'),
      regex: /^[A-Za-zÀÁÂÃÄÅÆÇÈÉÊÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿœŒ-\s]{2,25}$/,
      validErrorMessage: t('ek_ap_personal_first-name_input_error-msg')
    }),
    lastName: formValidation({
      required: t('ek_ap_personal_last-name_input_error-msg'),
      regex: /^[A-Za-zÀÁÂÃÄÅÆÇÈÉÊÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿœŒ-\s]{2,25}$/,
      validErrorMessage: t('ek_ap_personal_last-name_input_error-msg')
    }),
    birthDate: Yup.date()
      .transform((value, originalValue) => {
        // Parse the date using Moment.js
        const parsedDate = moment(originalValue, 'DD.MM.YYYY', true); // strict parsing
        // If the date is valid and the day and month match the original values, return the date object
        // Otherwise, return an `InvalidDate`
        if (parsedDate.isValid()) {
          const [day, month, year] = originalValue.split('.');
          if (
            parsedDate.date() === parseInt(day, 10) &&
            parsedDate.month() + 1 === parseInt(month, 10)
          ) {
            return parsedDate.toDate();
          }
        }
        return new Date(NaN); // Invalid date
      })
      .max(validateDOBde(), t('ek_ap_personal_birth-date_input_error-msg'))
      .required(t('ek_ap_personal_birth-date_input_error-msg2'))
      .typeError(t('ek_ap_personal_birth-date_input_error-msg3')),
    houseNumber: formValidation({
      required: t('ek_ap_personal_house-no_input_error-msg'),
      regex: /^[A-Za-z0-9ÄÖÜßäöü.-]{0,25}$/,
      validErrorMessage: t('ek_ap_personal_house-no_input_error-msg')
    }),
    street: formValidation({
      required: t('ek_ap_personal_street_input_error-msg'),
      regex: /^.{0,100}$/,
      validErrorMessage: t('ek_ap_personal_street_input_error-msg')
    }),
    emailAddress: formValidation({
      required: t('ek_ap_personal_email1_input_error-msg'),
      regex:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      validErrorMessage: t('ek_ap_personal_email1_input_error-msg')
    }),
    zip: formValidation({
      required: t('ek_ap_personal_zip_input_error-msg'),
      regex: /^[0-9]{0,25}$/,
      validErrorMessage: t('ek_ap_personal_zip_input_error-msg')
    }),
    city: formValidation({
      required: t('ek_ap_personal_town_input_error-msg'),
      regex:
        /^[a-zA-Z0-9-`ºªµ¼½¿ÀÁÂÃÄÅÆÇÈÉÊÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿœŒ´¡]{0,75}$/,
      validErrorMessage: t('ek_ap_personal_town_input_error-msg')
    }),
    termsAndConditions: Yup.boolean().isTrue(t('ek_ap_overview_text1_error-msg')),
    thirdParty: Yup.boolean(t('ek_ap_overview_text2_error-msg'))
  });
  const [overviewForm, setOverviewForm] = useState(overviewInitialValue);

  // Step 6 - Part A (Select Product & Process To Payment) Initial Values & Validations

  const processToPaymentInitialValue = {
    isDirectProduct: 'NO',
    type: appTopUpType.AUTOMATIC,
    chargeTo: appTopUpTo.SELF,

    productId: '',
    productType: '',
    productAmount: '',
    paymentMethodName: '', // appPaymentMethods
    terms: false
  };

  const processToPaymentValidations = Yup.lazy((values) => {
    if (values.periodType === appAutoTopUpPeriodType.ONCE_PER_MONTH) {
      return Yup.object().shape({
        periodDay: formValidation({ required: t('ek_ap_topup_amount_error-msg') }),
        productId: formValidation({ required: t('ek_ap_select_product_error-msg') })
      });
    }
    if (values.periodType === appAutoTopUpPeriodType.LOW_BALANCE) {
      return Yup.object().shape({
        periodAmount: formValidation({ required: t('ek_ap_topup_day_error-msg') }),
        productId: formValidation({ required: t('ek_ap_select_product_error-msg') })
      });
    }
    return Yup.object().shape({
      productId: formValidation({ required: t('ek_ap_select_product_error-msg') })
    });
  });

  const processToProductValidations = Yup.object().shape({
    periodType: formValidation({
      required: t('please_select_option_to_continue')
    }),
    periodDay: formValidation({}).when('periodType', {
      is: (value) => value === appAutoTopUpPeriodType.ONCE_PER_MONTH,
      then: formValidation({
        required: t('ek_autotop-up_setup_option2')
      })
    })
  });

  const productValidation = Yup.lazy((values) => {
    const validationSchema = {
      productId: formValidation({ required: t('ek_reg_step6_item_err') }),
      paymentMethodName: formValidation({ required: t('ek_reg_step6_method_err') }),
      terms: formValidation({
        type: DEFAULT_FIELD_VALIDATION_TYPE.BOOLEAN,
        required: t('ek_reg_step6_terms_err')
      })
    };
    return Yup.object().shape(validationSchema);
  });

  const [processToPaymentForm, setProcessToPaymentForm] = useState(processToPaymentInitialValue);
  // Step 6 - Part B (Select Payment Method & Process Order) Initial Values & Validations
  const chargingInitialValue = {
    paymentMethodName: ''
  };
  const chargingValidations = Yup.object().shape({
    paymentMethodName: formValidation({
      required: 'please_select_paymentMethod',
      type: DEFAULT_FIELD_VALIDATION_TYPE.STRING
    })
  });
  const [chargingForm, setChargingForm] = useState(chargingInitialValue);
  const [emailModal, setEmailModal] = useState(false);

  // Data Fetch Functions

  // Stepper Functions
  const nextStep = () => setCurrentStep(currentStep + 1);
  const prevStep = () => setCurrentStep(currentStep - 1);

  // Sub Stepper Functions for step 0
  const nextSubStep0 = () => setStep0SubStep(step0SubStep + 1);
  const prevSubStep0 = () => setStep0SubStep(step0SubStep - (step0SubStep === 2 ? 2 : 1));

  // Step 1 On Phone Number Form Submit
  const phoneNumberSubmit = async (values) => {
    setIsLoading(true);
    try {
      const params = { msisdn: values.msisdn, puk: values.puk };
      const { msisdn, puk } = values;

      const {
        status,
        data: { bookableTariffs: userBookableTariffs = [] }
      } = await onValidateSim(params);

      if (status === 200) {
        setPhoneNumberActivationForm({ ...phoneNumberActivationForm, msisdn, puk });
        setBookableTariffs(staticTariffManipulation(userBookableTariffs));
        setBookableTariffsEtcOne(userBookableTariffs);
      } else {
        throw new Error('Invalid msisdn or puk');
      }
      setStep1SubStep(1);
      setShowActivationHeader(false);
      setFormError(null);
      setIsLoading(false);
      return true;
    } catch (error) {
      setIsLoading(false);
      if (
        // validate-sim delivers 403 error and we want to show it, so no check on StatusCodes.FORBIDDEN
        !(
          error?.status === StatusCodes.UNAUTHORIZED ||
          error?.response?.status === StatusCodes.UNAUTHORIZED
        )
      ) {
        setFormError(error?.error?.[0]?.messageBody);
      }
      return false;
    }
  };

  const verifyEmail = async (values) => {
    try {
      setIsLoading(true);
      const uniqueIdEmail = generateUUID();
      setEmailUniqueId(uniqueIdEmail);
      const { data, success } = await onTwoFactorAuthPinCall({
        email: values.email,
        uniqueId: uniqueIdEmail
      });
      if (data && success) {
        setEmailModal(true);
        setPhoneNumberActivationForm({ ...phoneNumberActivationForm, email: values.email });
        setTimeout(() => {
          setEmailModal(false);
        }, 4000);
      }
      setFormError(null);
      if (step0SubStep === 0) setStep0SubStep(1);
      if (step0SubStep === 2) setStep0SubStep(4);
      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
      setFormError(t(error?.error?.[0]?.messageBody));
      return false;
    }
  };

  const verifyEmailCode = async (values) => {
    try {
      setIsLoading(true);
      const { data, success } = await onTwoFactorAuthVerificationCall({
        pin: Number(values.emailCode),
        uniqueId: emailUniqueId
      });
      if (data && success) {
        setPhoneNumberActivationForm({ ...phoneNumberActivationForm, emailCode: values.emailCode });
        setPersonalDataForm({ ...personalDataForm, emailAddress: phoneNumberActivationForm.email });
      }
      setFormError(null);
      nextSubStep0();
      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
      if (
        !(
          error?.status === StatusCodes.UNAUTHORIZED ||
          error?.status === StatusCodes.FORBIDDEN ||
          error?.response?.status === StatusCodes.UNAUTHORIZED ||
          error?.response?.status === StatusCodes.FORBIDDEN
        )
      ) {
        setEmailCodeError(true);
        setFormError(t(error?.error?.[0]?.messageBody));
      }
      return false;
    }
  };

  // Resend otp code
  const onResendCode = async () => {
    try {
      setIsLoading(true);
      const resendUniqueId = generateUUID();
      setEmailUniqueId(resendUniqueId);
      const { data, success } = await onTwoFactorAuthPinCall({
        email: phoneNumberActivationForm.email,
        uniqueId: resendUniqueId
      });
      if (data && success) {
        setIsLoading(false);
        setEmailModal(true);
        setTimeout(() => {
          setEmailModal(false);
        }, 4000);
      }
      return true;
    } catch (error) {
      setIsLoading(false);
      if (
        !(
          error?.status === StatusCodes.UNAUTHORIZED ||
          error?.status === StatusCodes.FORBIDDEN ||
          error?.response?.status === StatusCodes.UNAUTHORIZED ||
          error?.response?.status === StatusCodes.FORBIDDEN
        )
      ) {
        showAlert({ type: appAlert.ERROR, message: t(error?.error?.[0]?.messageBody) });
      }
      return false;
    }
  };

  const phoneNumberActivationFormSubmit = (values) => {
    // Validate sim & get tariff & got to next step;
    try {
      const { mnp, currentProvider, oldNumber, oldNumberPrefix } = values;
      setIsLoading(true);
      if (mnp) {
        setPhoneNumberActivationForm({
          ...phoneNumberActivationForm,
          mnp,
          currentProvider,
          oldNumber,
          oldNumberPrefix
        });
      }
      nextStep();
      setIsLoading(false);
      return true;
    } catch (error) {
      setIsLoading(false);
      return false;
    }
  };

  const getCountries = async () => {
    try {
      const { data = [] } = await oncountriesCall();
      if (data && data.length > 0) {
        setCountriesError(null);
        const sortedCountries = data.sort((a, b) => {
          // 'Deutschland' should show first in the list
          if (a.id === 1 && a.value === 'Deutschland') return -1;
          if (b.id === 1 && b.value === 'Deutschland') return 1;
          // sort alphabetically by country name
          return a.value.localeCompare(b.value);
        });
        setCountries(sortedCountries);

        const findFirst = sortedCountries.find((a) => a.id);
        if (findFirst && findFirst.id) {
          setPersonalDataForm({ ...personalDataForm, countryCode: findFirst.id });
        }
      }
      return data;
    } catch (error) {
      setCountriesError(error?.error?.[0]?.messageBody);
      return false;
    }
  };

  const getSalutation = async () => {
    try {
      const { data = [], success = false } = await onsalutationCall();
      if (data && data.length > 0 && success) {
        setSalutations(data);
        const findFirst = data.find((a) => a.id);
        if (findFirst && findFirst.id) {
          setPersonalDataForm({ ...personalDataForm, salutation: findFirst.id });
          return setTimeout(() => data, 10000);
        }
      }
      return data;
    } catch (error) {
      showAlert({ type: appAlert.ERROR, message: t(error?.error?.[0]?.messageBody) });
      setSalutations(DEFAULT_SALUTATION_DATA);
      return false;
    }
  };

  const getAreaCode = async () => {
    try {
      const { data = [] } = await onAreaCode();
      if (data && data.length > 0) {
        setAreaCodeError(null);
        setAreaCode(data);
        const findFirst = data.find((a) => a.id);
        if (findFirst && findFirst.id) {
          setPersonalDataForm({ ...personalDataForm, oldNumberPrefix: findFirst.id });
        }
      }
      return data;
    } catch (error) {
      setAreaCodeError(error?.error?.[0]?.messageBody);
      return false;
    }
  };

  const getSimProvider = async () => {
    try {
      const { data = {} } = await onSimProvider();
      if (data && data.length > 0) {
        setSimProviderError(null);
        setSimProvider(data);
        const findFirst = data.find((a) => a.id);
        if (findFirst && findFirst.id) {
          setPersonalDataForm({ ...personalDataForm, currentProvider: findFirst.id });
          return data;
        }
        return data;
      }
      return data;
    } catch (error) {
      setSimProviderError(error?.error?.[0]?.messageBody);
      return false;
    }
  };
  const getLookup = async () => {
    showLoader();
    setIsLoading(true);
    getSalutation();
    getCountries();
    getAreaCode();
    getSimProvider();
    setIsLoading(false);
    hideLoader();
  };

  useEffect(() => {
    if (showActivationCancelModal) {
      document.getElementsByTagName('button')?.[0]?.focus();
    }
  }, [showActivationCancelModal]);

  // CLEANUP: Remove IP Address
  // ALPHA: Remove IP Address
  useEffect(() => {
    setIp('');
  }, []);

  // Step 2 On Tariff Form Submit
  const tariffActivationFormSubmit = (values) => {
    setIsLoading(true);
    setTariffActivationForm(values);
    setIsLoading(false);
    nextStep();
  };

  const personalDataCallback = (values) => {
    const updatedDate = moment(values.birthDate, 'DD.MM.YYYY').format('DD.MM.YYYY');
    const updatedValues = { ...values, birthDate: updatedDate };
    setPersonalDataForm(updatedValues);
    setValidateAddressRes(null);
    setFormError(false);
    setIsLoading(false);
    // if (currentStep === 9) { // this is the NORMA implementation
    if (step9SubStep === 6) {
      setStep9SubStep(0);
    } else {
      nextStep();
    }
  };

  // Step 3 On Personal Data Form Submit
  const personalDataFormSubmit = async (values) => {
    try {
      setIsLoading(true);
      const params = {
        houseNumber: values.houseNumber,
        street: values.street,
        city: values.city,
        zip: values.zip,
        countryCode: values.countryCode
      };
      if (initialAddressParam) {
        const differences = Object.keys(initialAddressParam).some((key) => {
          if (Object.prototype.hasOwnProperty.call(params, key)) {
            return params[key] !== initialAddressParam[key];
          }
          return false;
        });
        if (!differences) {
          personalDataCallback({ ...values, ...validateAddressRes });
          return;
        }
      }
      const {
        status,
        data: { data }
      } = await onValidateAddress(params);

      if (status === 200) {
        const differences = Object.keys(data).some((key) => {
          if (Object.prototype.hasOwnProperty.call(params, key)) {
            return params[key] !== data[key];
          }
          return false;
        });

        if (differences) {
          setValidateAddressRes(data);
          setInitialAddressParam(params);
          setFormError(false);
          setIsLoading(false);
        } else {
          personalDataCallback(values);
        }
      } else {
        setIsLoading(false);
        throw new Error('Invalid');
      }
      return true;
    } catch (error) {
      setValidateAddressRes(null);
      setFormError(error?.error?.[0]?.messageBody);
      setInitialAddressParam(null);
      setIsLoading(false);
      return false;
    }
  };

  // Step 5 On Login Password Form Submit
  const loginPasswordFormSubmit = (values) => {
    if (!validatePwd(values.cscPassword)) {
      setChangePasswordErrorMsg(errorMessageInvalidChar);
      setIsLoading(false);
      return false;
    }

    setIsLoading(true);
    setPersonalDataForm({
      ...personalDataForm,
      cscPassword: values.cscPassword
    });
    setOverviewForm({
      ...overviewForm,
      msisdn: personalDataForm.msisdn,
      chosenTariffId: tariffActivationForm.chosenTariffId
    });
    setIsLoading(false);
    setShowActivationHeader(false);
    setStep5SubStep(step5SubStep + 1);
    return true;
  };

  const voucherDataValidations = Yup.object().shape({
    voucherCode: formValidation({
      required: 'ek_global_voucher_code_err'
    })
  });

  const checkVoucherCode = async (codeForValidation) => {
    try {
      setIsLoading(true);
      const { data, status } = await onValidateCode({ codeForValidation });
      if (status === 200 && data?.valid) {
        setIsLoading(false);
        setFormError(null);
        setVoucherGBNo(data?.bonusGb);
        setPersonalDataForm({
          ...personalDataForm,
          invitationCode: codeForValidation
        });
        setShowActivationHeader(false);
        setStep4SubStep(1);
        return data;
      }
      setIsLoading(false);
      throw new Error('invalid voucher code');
    } catch (error) {
      // error handling in API-Proxy for this call
      setIsLoading(false);
      if (
        !(
          error?.status === StatusCodes.UNAUTHORIZED ||
          error?.status === StatusCodes.FORBIDDEN ||
          error?.response?.status === StatusCodes.UNAUTHORIZED ||
          error?.response?.status === StatusCodes.FORBIDDEN
        )
      ) {
        setVoucherCodeError(error?.error?.[0]?.messageBody);
      }
    }
    return false;
  };

  const getVviDocuments = async () => {
    showLoader();
    setIsLoading(true);
    try {
      const { data, success } = await onVviDocuments({
        tariffId: tariffActivationForm.chosenTariffId,
        mnp: withMNP
      });
      if (success) {
        setVviDocuments(data);
      }
      setIsLoading(false);
      hideLoader();
      return true;
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      hideLoader();
      if (
        !(
          error?.status === StatusCodes.UNAUTHORIZED ||
          error?.status === StatusCodes.FORBIDDEN ||
          error?.response?.status === StatusCodes.UNAUTHORIZED ||
          error?.response?.status === StatusCodes.FORBIDDEN
        )
      ) {
        showAlert({ type: appAlert.ERROR, message: t(error?.error?.[0]?.messageBody) });
      }
      return error;
    }
  };

  const onConfirmingLegitimationMethod = (id, name) => {
    setPersonalDataForm({
      ...personalDataForm,
      legitimationMethod: id,
      legitimationName: name
    });
    setShowActivationHeader(false);
    setStep6SubStep(1);
  };

  const onUpdateLegitimationMethod = (id, name) => {
    setPersonalDataForm({
      ...personalDataForm,
      legitimationMethod: id,
      legitimationName: name
    });
    setStep9SubStep(0);
  };

  const getLegitimationMethods = async () => {
    setIsLoading(true);
    try {
      const { data, status } = await onLegitimationMethodsCall();
      if (status === 200) {
        setLegitimationError(null);
        const legitimationMethodsInCms = staticContentData.ek_legitimationMethods;
        const updateData = data
          .filter((method) => legitimationMethodsInCms?.find((d) => d.legitimationId === method.id))
          .map((method) => ({
            ...legitimationMethodsInCms?.find((d) => d.legitimationId === method.id)
          }))
          .map((method) => {
            if (method.buttonProps) {
              method.buttonProps = method.buttonProps.map((button) => {
                if (button.onPress === 'chooseLegitimation') {
                  button.onPress = () =>
                    onConfirmingLegitimationMethod(method.legitimationId, method.name);
                }
                return button;
              });
            }
            return method;
          })
          .sort((method) => (method.isRecomended ? -1 : 1));
        setLegitimationMethods(updateData);
      }
      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
      if (
        !(
          error?.status === StatusCodes.UNAUTHORIZED ||
          error?.status === StatusCodes.FORBIDDEN ||
          error?.response?.status === StatusCodes.UNAUTHORIZED ||
          error?.response?.status === StatusCodes.FORBIDDEN
        )
      ) {
        setLegitimationError(error?.error?.[0]?.messageBody);
      }
      return false;
    }
  };

  const updateLegitimationMethods = () => {
    let tempMethods = legitimationMethods;
    tempMethods = tempMethods.map((method) => {
      if (method.buttonProps) {
        method.buttonProps = method.buttonProps.map((button) => {
          button.onPress = () => onUpdateLegitimationMethod(method.legitimationId, method.name);
          return button;
        });
      }
      return method;
    });
    setLegitimationMethods(tempMethods);
  };

  const overviewFormSubmit = async (values) => {
    try {
      setOverviewError(false);

      // 🔴 [STATE RECOVERY] Fallback: If Context array is empty but sessionStorage has data, restore it
      let methodsToUse = legitimationMethods;
      if (!legitimationMethods || legitimationMethods.length === 0) {
        const sessionStoredMethods = sessionStorage.getItem('mps_legitimation_methods');
        if (sessionStoredMethods) {
          try {
            methodsToUse = JSON.parse(sessionStoredMethods);
          } catch (err) {
            // console.error('Failed to parse legitimation methods from sessionStorage:', err);
          }
        }
      }

      const {
        paymentRedisKey, // Extract paymentRedisKey from form params (lookup_key from payment result)
        msisdn,
        puk,
        mnp,
        currentProvider,
        type,
        oldNumber,
        oldNumberPrefix,
        chosenTariffId,
        cscPassword,
        birthDate,
        emailAddress,
        firstName,
        lastName,
        title,
        city,
        countryCode,
        houseNumber,
        street,
        zip,
        legitimationMethod,
        invitationCode,
        acceptedCreditCheck,
        brandPartnerCustomMarketing,
        employee,
        marketingMultibrand,
        termsAndConditions,
        thirdParty
      } = values;
      setIsLoading(true);

      // correct birthDate to ISO date format
      const updatedBirthDate = moment(birthDate, 'DD.MM.YYYY', true).format('YYYY-MM-DD');

      // MPS: we have a new top level object 'activation' which encapsulates the activation data
      // paymentRedisKey is attached at the top level for backend's activate-sim endpoint
      const params = mnp
        ? {
            payment_redis_key: paymentRedisKey || '', // Add payment_redis_key for auto-topup setup link
            activation: {
              activationData: {
                msisdn,
                puk
              },
              activationMNPData: {
                currentProvider,
                mnp,
                oldNumber: {
                  number: oldNumber,
                  prefix: oldNumberPrefix.toString()
                },
                type: Number(type)
              },
              chosenTariffId,
              cscPassword,
              legitimationMethod,
              invitationCode,
              personalData: {
                address: {
                  city,
                  countryCode: Number(countryCode),
                  houseNumber,
                  street,
                  zip
                },
                birthDate: updatedBirthDate, // former birthDate value
                emailAddress,
                firstName,
                flags: {
                  acceptedCreditCheck,
                  brandPartnerCustomMarketing,
                  employee,
                  marketingMultibrand,
                  termsAndConditions,
                  thirdParty
                },
                lastName,
                salutation: Number(3),
                title: Number(title)
              }
            }
          }
        : {
            payment_redis_key: paymentRedisKey || '', // Add payment_redis_key for auto-topup setup link
            activation: {
              activationData: {
                msisdn,
                puk
              },
              chosenTariffId,
              cscPassword,
              legitimationMethod,
              invitationCode,
              personalData: {
                address: {
                  city,
                  countryCode: Number(countryCode),
                  houseNumber,
                  street,
                  zip
                },
                birthDate: updatedBirthDate, // former birthDate value
                emailAddress,
                firstName,
                flags: {
                  acceptedCreditCheck,
                  brandPartnerCustomMarketing,
                  employee,
                  marketingMultibrand,
                  termsAndConditions,
                  thirdParty
                },
                lastName,
                salutation: Number(3),
                title: Number(title)
              }
            }
          };

      // ---------------------Activation Step---------------------

      const {
        data = {},
        data: {
          signupId: clientId = '',
          // legacy value when POSTIDENT was the only legitimation method
          postidentUrl: postidentUrlFromActivateSim = '',
          // handle new response field legitimationUrl
          legitimationUrl: legitimationUrlFromActivateSim = ''
        }
      } = await paymentService.handleActivateSim(params);

      // DEBUG LOGS
      // console.log('🔵 mpsOverviewFormSubmit - Backend Response:', {
      //   signupId: clientId,
      //   postidentUrl: postidentUrlFromActivateSim,
      //   legitimationUrl: legitimationUrlFromActivateSim
      // });
      // console.log('🔵 legitimationMethod being sent:', legitimationMethod);
      // console.log('🔵 Available legitimationMethods array (using recovered data):', methodsToUse);

      if (data) {
        // get legitimation code from legitimation URL
        let legitimationCodeInUse = '';
        const usedLegitimationMethod = methodsToUse.find(
          (element) => element.legitimationId === legitimationMethod
        );
        const legitimationCodeParameterName = usedLegitimationMethod?.codeParameterName;

        if (legitimationCodeParameterName && legitimationUrlFromActivateSim) {
          try {
            let url = new URL(legitimationUrlFromActivateSim);
            legitimationCodeInUse = url.searchParams.get(legitimationCodeParameterName);
          } catch (urlError) {
            // console.error('Failed to parse legitimationUrl:', urlError);
          }
        }

        // Set Legitimation & Activation Data To Storage
        await storage.encryptedSetItem(appStorage.ACTIVATION_MSISDN, msisdn);
        await storage.encryptedSetItem(appStorage.ACTIVATION_DATA, JSON.stringify(data));
        await storage.encryptedSetItem(appStorage.ACTIVATION_PERSONAL_DATA, JSON.stringify(values));
        // legacy value when POSTIDENT was the only legitimation method
        await storage.encryptedSetItem(appStorage.POSTIDENT, postidentUrlFromActivateSim);
        await storage.encryptedSetItem(appStorage.LEGITIMATION_URL, legitimationUrlFromActivateSim);
        await storage.encryptedSetItem(appStorage.LEGITIMATION_CODE, legitimationCodeInUse);
        await storage.encryptedSetItem(
          appStorage.LEGITIMATION_NAME,
          personalDataForm.legitimationName
        );
        // legacy value when POSTIDENT was the only legitimation method
        setPostIdentUrl(postidentUrlFromActivateSim);
        setLegitimationUrl(legitimationUrlFromActivateSim);
        setLegitimationCode(legitimationCodeInUse);
      }

      setIsLoading(false);
      setStep9SubStep(3);
      return params;
    } catch (error) {
      setIsLoading(false);
      setOverviewError(true);
      setStep9SubStep(4);
      return false;
    }
  };

  const navigateToCallback = () => {
    navigate(`${appRoute.ACTIVATION_PAYMENT_CALLBACK}?paymentError=yes`);
  };

  const onClickBack = () => {
    setCurrentStep(0);
    setPhoneNumberActivationForm(phoneNumberInitialValue);
    setTariffActivationForm(tariffActivationInitialValue);
    setPersonalDataForm(personalDataInitialValue);
    setOverviewForm(overviewInitialValue);
    setIsActivationClicked(false);
  };

  const onFailedPayment = async () => {
    try {
      const aData = await storage.encryptedGetItem(appStorage.ACTIVATION_DATA);
      const aPersonalData = await storage.encryptedGetItem(appStorage.ACTIVATION_PERSONAL_DATA);
    } catch (error) {
      // console.log(error);
    }
  };

  const deleteStorage = async () => {
    await storage.encryptedRemoveItem(appStorage.ACTIVATION_MSISDN);
    await storage.encryptedRemoveItem(appStorage.ACTIVATION_DATA);
    await storage.encryptedRemoveItem(appStorage.ACTIVATION_PERSONAL_DATA);
    await storage.encryptedRemoveItem(appStorage.POSTIDENT);
    await storage.encryptedRemoveItem(appStorage.LEGITIMATION_URL);
    await storage.encryptedRemoveItem(appStorage.LEGITIMATION_CODE);
    await storage.encryptedRemoveItem(appStorage.LEGITIMATION_NAME);

    // Clear MPS sessionStorage
    await storage.encryptedRemoveItem('mps_activation_tariff');
    await storage.encryptedRemoveItem('mps_activation_phone');
    await storage.encryptedRemoveItem('mps_activation_personal');
    await storage.encryptedRemoveItem('mps_activation_withAutoTopup');
    await storage.encryptedRemoveItem('mps_activation_withMnp');
    await storage.encryptedRemoveItem('mps_bookable_tariffs');
    await storage.encryptedRemoveItem('mps_bookable_tariffs_etc_one');
    await storage.encryptedRemoveItem('mps_legitimation_methods');
    await storage.encryptedRemoveItem('mps_payment_result');
    await storage.encryptedRemoveItem('mps_payment_flow');
    await storage.encryptedRemoveItem('mps_payment_amount');
    await storage.encryptedRemoveItem('mps_payment_method');
    await storage.encryptedRemoveItem('mps_payment_msisdn');
    await storage.encryptedRemoveItem('mps_payment_email');
    await storage.encryptedRemoveItem('mps_lookup_key');
    // sessionStorage.removeItem('mps_activation_tariff');
    // sessionStorage.removeItem('mps_activation_phone');
    // sessionStorage.removeItem('mps_activation_personal');
    // sessionStorage.removeItem('mps_activation_withAutoTopup');
    // sessionStorage.removeItem('mps_activation_withMnp');
    // sessionStorage.removeItem('mps_bookable_tariffs');
    // sessionStorage.removeItem('mps_bookable_tariffs_etc_one');
    // sessionStorage.removeItem('mps_legitimation_methods');
    // sessionStorage.removeItem('mps_payment_result');
    // sessionStorage.removeItem('mps_payment_flow');
    // sessionStorage.removeItem('mps_payment_amount');
    // sessionStorage.removeItem('mps_payment_method');
    // sessionStorage.removeItem('mps_payment_msisdn');
    // sessionStorage.removeItem('mps_payment_email');
    // sessionStorage.removeItem('mps_lookup_key');

    // NOTE: to check if the cart and order number can be removed (ALPHACOMM?)
    // await storage.encryptedRemoveItem(appStorage.CART_NAME);
    // await storage.encryptedRemoveItem(appStorage.ORDER_NUMBER);
    // NOTE: Still Used (legacy fallbacks)
    await storage.encryptedRemoveItem(appStorage.TOPUP_AMOUNT);
    await storage.encryptedRemoveItem(appStorage.TOPUP_TYPE);
    // ALPHA: consider to remove all old local storage values related to Alphacomm payment
    // await storage.encryptedRemoveItem(appStorage.PAYMENT_TOKEN);
    // await storage.encryptedRemoveItem(appStorage.PAYMENT_REFRESH_TOKEN);
  };

  // Clear all activation states
  const clearActivationStates = async (shouldDeleteStorage = false) => {
    setPhoneNumberActivationForm(phoneNumberInitialValue);
    setTariffActivationForm(tariffActivationInitialValue);
    setPersonalDataForm(personalDataInitialValue);
    setOverviewForm(overviewInitialValue);
    setIsActivationClicked(false);
    setWithVoucher(false);
    if (shouldDeleteStorage) {
      await deleteStorage();
    }
    // reset step handling
    setCurrentStep(0);
    setStep0SubStep(0);
  };

  // handle cancellation of activation journey
  const handleCancelButtonClick = () => {
    setShowActivationCancelModal(false);
    setShowActivationHeader(false);
    clearActivationStates(true);
    navigate(appRoute.HOME_PAGE);
  };

  const getTariffName = (
    tariffName,
    tariffNameSpeed,
    tariffNameCmsKey = 'ek_dboard_dts_tariff'
  ) => {
    let nameOfTariff = tA11y(tariffNameCmsKey);
    const shownName = tA11y(tariffName).content;
    nameOfTariff = replaceDynamicCmsContent(nameOfTariff, '{TARIFFNAME}', shownName);
    const shownSpeed = tA11y(tariffNameSpeed).content;
    if (shownSpeed) {
      nameOfTariff = replaceDynamicCmsContent(nameOfTariff, '{SPEEDNAME}', shownSpeed);
    } else {
      nameOfTariff = replaceDynamicCmsContent(nameOfTariff, '{SPEEDNAME}', '');
    }
    return nameOfTariff;
  };

  // We wrap it in a useMemo for performance reason
  const contextPayload = useMemo(
    () => ({
      // States
      currentStep,
      setCurrentStep,
      isLoading,
      setIsLoading,
      bookableTariffs,
      setBookableTariffs,
      bookableTariffsEtcOne,
      setBookableTariffsEtcOne,
      paymentProducts,
      setPaymentProducts,
      allPaymentProducts,
      setAllPaymentProducts,
      otherAmount,
      setOtherAmount,
      showAddress,
      setShowAddress,
      cartName,
      setCartName,
      orderNumber,
      setOrderNumber,
      paymentUrl,
      setPaymentUrl,
      postIdentUrl,
      setPostIdentUrl,
      paymentMethod,
      setPaymentMethod,
      selectedTariffId,
      setSelectedTariffId,
      simProvider,
      countries,
      setCountries,
      identityTypes,
      setIdentityTypes,
      nationality,
      setNationality,
      areaCode,
      setAreaCode,
      salutations,
      setSalutations,
      isSimInvalid,
      setIsSimInvalid,
      emailModal,
      setEmailModal,
      isChargingClicked,
      setIsChargingClicked,
      activateSimSuccessPopup,
      setActivateSimSuccessPopup,
      showBackButton,
      setShowBackButton,
      isActivationClicked,
      setIsActivationClicked,
      isPaymentProductLoading,
      setIsPaymentProductLoading,
      isPaymentMethodLoading,
      setIsPaymentMethodLoading,
      autoTopupMoreInfo,
      setAutoTopupMoreInfo,
      step0SubStep,
      setStep0SubStep,
      showActivationHeader,
      setShowActivationHeader,
      showActivationFooter,
      setShowActivationFooter,
      showActivationCancelModal,
      setShowActivationCancelModal,
      showFeedbackSuccess,
      setShowFeedbackSuccess,
      showFeedbackError,
      setShowFeedbackError,
      step1SubStep,
      setStep1SubStep,
      step2SubStep,
      setStep2SubStep,
      step3SubStep,
      setStep3SubStep,
      step4SubStep,
      setStep4SubStep,
      step5SubStep,
      setStep5SubStep,
      step6SubStep,
      setStep6SubStep,
      step7SubStep,
      setStep7SubStep,
      step8SubStep,
      setStep8SubStep,
      step9SubStep,
      setStep9SubStep,
      step10SubStep,
      setStep10SubStep,
      withMNP,
      setWithMNP,
      withVoucher,
      setWithVoucher,
      voucherGBNo,
      setVoucherGBNo,
      voucherCodeError,
      setVoucherCodeError,
      vviDocuments,
      setVviDocuments,
      withAutoTopup,
      setWithAutoTopup,
      errorAutoTopup,
      setErrorAutoTopup,

      // Form States
      phoneNumberActivationForm,
      setPhoneNumberActivationForm,
      tariffActivationForm,
      setTariffActivationForm,
      personalDataForm,
      setPersonalDataForm,
      overviewForm,
      setOverviewForm,
      processToPaymentForm,
      setProcessToPaymentForm,
      chargingForm,
      setChargingForm,
      loginPasswordForm,
      emailCodeError,
      setEmailCodeError,
      isAutoLowEnabled,
      setIsAutoLowEnabled,
      changePasswordErrorMsg,
      setChangePasswordErrorMsg,
      formError,
      setFormError,
      validateAddressRes,
      setValidateAddressRes,
      legitimationMethods,
      setLegitimationMethods,
      legitimationError,
      setLegitimationError,
      legitimationCode,
      setLegitimationCode,
      legitimationUrl,
      setLegitimationUrl,
      countriesError,
      setCountriesError,
      areaCodeError,
      setAreaCodeError,
      simProviderError,
      setSimProviderError,
      overviewError,
      setOverviewError,
      withMNPError,
      setWithMNPError,

      // Form Initial States & Validations
      phoneNumberInitialValue,
      phoneNumberValidations,
      validationSchemaEmail,
      phoneNumberValidationsWithMNP,
      tariffActivationInitialValue,
      tariffActivationValidation,
      personalDataInitialValue,
      personalDataValidations,
      // loginPasswordValidation,
      validatePasswordWithKeys,
      overviewInitialValue,
      overviewValidation,
      processToPaymentInitialValue,
      processToPaymentValidations,
      processToProductValidations,
      productValidation,
      chargingInitialValue,
      chargingValidations,
      voucherDataValidations,

      // Functions
      phoneNumberSubmit,
      verifyEmail,
      verifyEmailCode,
      validationSchemaCode,
      onResendCode,
      phoneNumberActivationFormSubmit,
      tariffActivationFormSubmit,
      personalDataFormSubmit,
      loginPasswordFormSubmit,
      overviewFormSubmit,
      // processToPayment,
      // chargingFormSubmit,
      getLookup,
      // CLEANUP: remove later
      // processWithPostIdent,
      onClickBack,
      // onTopupError,
      staticTariffManipulation,
      checkVoucherCode,
      getVviDocuments,
      getLegitimationMethods,
      updateLegitimationMethods,
      clearActivationStates,

      // Stepper Functions
      nextStep,
      prevStep,
      nextSubStep0,
      prevSubStep0,

      // Custom Validation for step one
      // CLEANUP: remove later
      // PhoneNumberCustomValidation,
      // ssoPaymentToken,
      onFailedPayment,
      handleCancelButtonClick,
      getTariffName
    }),
    [
      // States
      currentStep,
      setCurrentStep,
      isLoading,
      setIsLoading,
      bookableTariffs,
      setBookableTariffs,
      bookableTariffsEtcOne,
      setBookableTariffsEtcOne,
      paymentProducts,
      setPaymentProducts,
      allPaymentProducts,
      setAllPaymentProducts,
      otherAmount,
      setOtherAmount,
      showAddress,
      setShowAddress,
      cartName,
      setCartName,
      orderNumber,
      setOrderNumber,
      paymentUrl,
      setPaymentUrl,
      postIdentUrl,
      setPostIdentUrl,
      isSimInvalid,
      setIsSimInvalid,
      emailModal,
      setEmailModal,
      isChargingClicked,
      setIsChargingClicked,
      activateSimSuccessPopup,
      setActivateSimSuccessPopup,
      showBackButton,
      setShowBackButton,
      isActivationClicked,
      setIsActivationClicked,
      emailCodeError,
      setEmailCodeError,
      isAutoLowEnabled,
      setIsAutoLowEnabled,
      isPaymentProductLoading,
      setIsPaymentProductLoading,
      isPaymentMethodLoading,
      setIsPaymentMethodLoading,
      autoTopupMoreInfo,
      setAutoTopupMoreInfo,
      setStep0SubStep,
      step0SubStep,
      showActivationHeader,
      setShowActivationHeader,
      showActivationFooter,
      setShowActivationFooter,
      showActivationCancelModal,
      setShowActivationCancelModal,
      showFeedbackSuccess,
      setShowFeedbackSuccess,
      showFeedbackError,
      setShowFeedbackError,
      step1SubStep,
      setStep1SubStep,
      step2SubStep,
      setStep2SubStep,
      step3SubStep,
      setStep3SubStep,
      step4SubStep,
      setStep4SubStep,
      step5SubStep,
      setStep5SubStep,
      step6SubStep,
      setStep6SubStep,
      step7SubStep,
      setStep7SubStep,
      step8SubStep,
      setStep8SubStep,
      step9SubStep,
      setStep9SubStep,
      step10SubStep,
      setStep10SubStep,
      withMNP,
      setWithMNP,
      withVoucher,
      setWithVoucher,
      voucherGBNo,
      setVoucherGBNo,
      voucherCodeError,
      setVoucherCodeError,
      vviDocuments,
      setVviDocuments,
      withAutoTopup,
      setWithAutoTopup,
      errorAutoTopup,
      setErrorAutoTopup,
      legitimationMethods,
      setLegitimationMethods,
      legitimationError,
      setLegitimationError,
      legitimationCode,
      setLegitimationCode,
      legitimationUrl,
      setLegitimationUrl,
      countriesError,
      setCountriesError,
      areaCodeError,
      setAreaCodeError,
      simProviderError,
      setSimProviderError,
      overviewError,
      setOverviewError,
      withMNPError,
      setWithMNPError,

      // Form States
      phoneNumberActivationForm,
      setPhoneNumberActivationForm,
      tariffActivationForm,
      setTariffActivationForm,
      personalDataForm,
      setPersonalDataForm,
      overviewForm,
      setOverviewForm,
      processToPaymentForm,
      setProcessToPaymentForm,
      chargingForm,
      setChargingForm,
      loginPasswordForm,
      changePasswordErrorMsg,
      setChangePasswordErrorMsg,
      formError,
      setFormError,
      validateAddressRes,
      setValidateAddressRes,

      // Form Initial States & Validations
      phoneNumberInitialValue,
      phoneNumberValidations,
      validationSchemaEmail,
      phoneNumberValidationsWithMNP,
      tariffActivationInitialValue,
      tariffActivationValidation,
      personalDataInitialValue,
      personalDataValidations,
      // loginPasswordValidation,
      validatePasswordWithKeys,
      overviewInitialValue,
      overviewValidation,
      processToPaymentInitialValue,
      processToPaymentValidations,
      processToProductValidations,
      productValidation,
      chargingInitialValue,
      chargingValidations,
      voucherDataValidations,

      // Functions
      phoneNumberSubmit,
      verifyEmail,
      verifyEmailCode,
      validationSchemaCode,
      onResendCode,
      phoneNumberActivationFormSubmit,
      tariffActivationFormSubmit,
      personalDataFormSubmit,
      loginPasswordFormSubmit,
      overviewFormSubmit,
      // processToPayment,
      // chargingFormSubmit,
      getLookup,
      // CLEANUP: remove later
      // processWithPostIdent,
      onClickBack,
      // onTopupError,
      staticTariffManipulation,
      checkVoucherCode,
      getVviDocuments,
      getLegitimationMethods,
      updateLegitimationMethods,
      clearActivationStates,

      // Stepper Functions
      nextStep,
      prevStep,
      nextSubStep0,
      prevSubStep0,

      // Custom Validation for step one
      // CLEANUP: remove later
      // PhoneNumberCustomValidation,
      // ssoPaymentToken,
      onFailedPayment,
      handleCancelButtonClick,
      getTariffName
    ]
  );

  // We expose the context's value down to our components, while
  // also making sure to render the proper content to the screen
  return <ActivationContext.Provider value={contextPayload}>{children}</ActivationContext.Provider>;
}

ActivationContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// A custom hook to quickly read the context's value. It's
// only here to allow quick imports
export const useActivation = () => useContext(ActivationContext);

export default ActivationContext;
